import { render } from "./RedeemVoucherSavePage.vue?vue&type=template&id=557c0d24"
import script from "./RedeemVoucherSavePage.vue?vue&type=script&lang=js"
export * from "./RedeemVoucherSavePage.vue?vue&type=script&lang=js"
script.render = render

export default script